import { useQuery } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import {
  GetUpliftRegions,
  GetUpliftRegionsVariables
} from '@/graphql/contracts/_generated_/getUpliftRegions.query';
import GetUpliftRegionsQuery from '@/graphql/contracts/getUpliftRegions.query.gql';
import { notificationService } from '@/services/notification/notification.client';

export const useGetUpliftRegions = () => {
  const { data, error, loading } = useQuery<GetUpliftRegions, GetUpliftRegionsVariables>(
    GetUpliftRegionsQuery,
    {
      client: apolloClientContracts,
      fetchPolicy: 'cache-and-network',
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
    }
  );

  return {
    data,
    loading,
    error,
    regions: data?.getUpliftRegions || []
  } as const;
};
